import { getAllPaymentsList } from 'entities/payments/api/getAllPaymentsList'
import { createCashPayment } from 'entities/payments/api/createCashPayment'
import { createCertificatePayment } from 'entities/payments/api/createCertificatePayment'
import { getPaymentsByOrderId } from 'entities/payments/api/getPaymentsByOrderId'
import { getPaymentMethods } from 'entities/payments/api/getPaymentMethods'
import { createAccountPayment } from 'entities/payments/api/createAccountPayment'
import { confirmAccountPayment } from 'entities/payments/api/confirmAccountPayment'
import { refundOrder } from 'entities/payments/api/refundOrder'
import { createOnlineCloudPayment } from 'entities/payments/api/createOnlineCloudPayment'
import { createOnlineYookassaPayment } from 'entities/payments/api/createOnlineYookassaPayment'
import { cancelPayment } from 'entities/payments/api/cancelPayment'

export const PaymentApi = {
    getAllPaymentsList,
    createCashPayment,
    createCertificatePayment,
    createOnlineCloudPayment,
    createOnlineYookassaPayment,
    getPaymentsByOrderId,
    getPaymentMethods,
    createAccountPayment,
    confirmAccountPayment,
    refundOrder,
    cancelPayment,
}
